var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinicalFe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 22H39V37.3333L40 38.6667L41 37.3333V22ZM43 38L40 42L37 38V20H43V38Z",
    fill: "#0078E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 15H39V17H41V15ZM39 13H41C42.1046 13 43 13.8954 43 15V19H37V15C37 13.8954 37.8954 13 39 13Z",
    fill: "#0078E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C12.4477 26 12 26.4477 12 27C12 27.5523 12.4477 28 13 28H27C27.5523 28 28 27.5523 28 27C28 26.4477 27.5523 26 27 26H13Z",
    fill: "#0078E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32C12 31.4477 12.4477 31 13 31H27C27.5523 31 28 31.4477 28 32C28 32.5523 27.5523 33 27 33H13C12.4477 33 12 32.5523 12 32Z",
    fill: "#0078E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36C12.4477 36 12 36.4477 12 37C12 37.5523 12.4477 38 13 38H23C23.5523 38 24 37.5523 24 37C24 36.4477 23.5523 36 23 36H13Z",
    fill: "#0078E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.9995C16.5523 14.9995 17 15.4472 17 15.9995V18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H17V21.9998C17 22.552 16.5523 22.9998 16 22.9998C15.4477 22.9998 15 22.552 15 21.9998V20H13C12.4477 20 12 19.5523 12 19C12 18.4477 12.4477 18 13 18H15V15.9995C15 15.4472 15.4477 14.9995 16 14.9995Z",
    fill: "#0078E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7C13 5.34315 14.3431 4 16 4H24C25.6569 4 27 5.34315 27 7H30C32.2091 7 34 8.79086 34 11V39C34 41.2091 32.2091 43 30 43H10C7.79086 43 6 41.2091 6 39V11C6 8.79086 7.79086 7 10 7H13ZM24 12C25.6569 12 27 10.6569 27 9H30C31.1046 9 32 9.89543 32 11V39C32 40.1046 31.1046 41 30 41H10C8.89543 41 8 40.1046 8 39V11C8 9.89543 8.89543 9 10 9H13C13 10.6569 14.3431 12 16 12H24ZM16 6C15.4477 6 15 6.44772 15 7V9C15 9.55228 15.4477 10 16 10H24C24.5523 10 25 9.55228 25 9V7C25 6.44772 24.5523 6 24 6H16Z",
    fill: "#0078E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalFe);
export default __webpack_public_path__ + "static/media/clinical_fe.a81b91ac5f32a306b3d254532b33ba48.svg";
export { ForwardRef as ReactComponent };